export const initialState = {
    pickup_latitude: null,
    pickup_longitude: null,
    dropoff_latitude: null,
    dropoff_longitude: null,
    pickup_address: "",
    dropoff_address: "",
    distance: "",
    duration: "",
    pet_ids: [],
    want_cage: false,
    two_way: false,
    emergency_no: "",
    promo_code: "",
    partners: null,
    services: ["taxi"],
    day: "",
    taxiSlot: null,
    slot_token: null,
    scheduled_at: false,
    scheduled_time: null,
    scheduleType:"instant",
    termsAccepted:false
};

export function deliveryReducer(state, action) {
    switch (action.type) {
        case "UPDATE_FIELD":
            return { ...state, [action.field]: action.payload };
        case "UPDATE_DAY":
            return { ...state, day: action.payload, taxiSlot: null };
       
        case "SET_TAXI_SLOT":
            return { ...state, taxiSlot: action.payload };
        case "LOAD_ITEM":
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
